
<section
  id="hero"
  class="l-hero"
>
  <div class="o-container">
    <!-- eslint-disable vue/no-v-html -->
    <h1
      class="l-hero__title"
      v-html="content.title"
    />

    <p
      class="l-hero__description"
      v-html="content.description"
    />
    <!-- eslint-enable -->
    <a
      v-webview-open-universal-link="'none'"
      :href="content.actionLink"
      class="l-hero__action l-button o-button -xs-large -xs-primary"
    >
      {{ content.actionText }}
    </a>
  </div>
</section>
